<script setup lang="tsx">
import type { TableColumnData, TableData } from '@arco-design/web-vue'
import arrowRightIcon from '~/assets/images/user/vip/arrow-right.png'
import UserSCard from '~/components/user/vip/SCard.vue'

const props = defineProps<{
  data: any
}>()
const { t } = useI18n()
function renderComparisonSection() {
  return (
    <div class="z-1 mx-auto box-border h-136 w-1170 flex justify-end gap-20 pr-48">
      <div class="flex flex-col items-end gap-10 px-10 text-36 font-300">
        {t('权益对比') }
        <img src={arrowRightIcon} class="w-24" />
      </div>
      {props.data?.map(item => (
        <UserSCard key={item.resource} pay-type={1} data={item} class="w-fit" />
      ))}
    </div>
  )
}

const columns: TableColumnData[] = [
  { title: '', dataIndex: 'account', align: 'center', width: 130 },
  { title: '', dataIndex: 'name', align: 'center', width: 127 },
  { title: '', dataIndex: 'paid1', slotName: 'package', align: 'center', width: 344 },
  { title: '', dataIndex: 'paid2', slotName: 'package', align: 'center', width: 298 },
  { title: '', dataIndex: 'paid3', slotName: 'package', align: 'center', width: 206 },
]
const tableData: TableData[] = [
  { id: 1, account: '', name: t('子账号'), paid1: t('可付费扩充'), paid2: 'no', paid3: 'no' },
  { id: 1, account: '', name: t('vip.查看详情'), paid1: t('vip.不限'), paid2: t('vip.不限'), paid3: `5${t('次/天')}` },
  { id: 1, account: '', name: t('vip.搜索次数'), paid1: t('vip.不限'), paid2: t('vip.不限'), paid3: `5${t('次/天')}` },
  { id: 2, account: t('商品数据'), name: t('商品库'), paid1: t('不限'), paid2: t('vip.upTo', [2000]), paid3: t('vip.upTo', [10]) },
  { id: 2, account: t('商品数据'), name: t('商品详情'), paid1: t('不限'), paid2: t('90天数据'), paid3: t('仅基础数据') },
  { id: 2, account: t('商品数据'), name: t('商品榜单'), paid1: t('vip.top', [1000]), paid2: t('vip.top', [500]), paid3: t('vip.top', [10]) },
  { id: 2, account: t('商品数据'), name: t('排序与筛选'), paid1: 'right', paid2: 'right', paid3: 'no' },
  { id: 3, account: t('小店数据'), name: t('小店库'), paid1: t('vip.不限'), paid2: t('vip.upTo', [2000]), paid3: t('vip.upTo', [10]) },
  { id: 3, account: t('小店数据'), name: t('小店详情'), paid1: t('vip.不限'), paid2: t('90天数据'), paid3: t('仅基础数据') },
  { id: 3, account: t('小店数据'), name: t('小店榜单'), paid1: t('vip.top', [1000]), paid2: t('vip.top', [500]), paid3: t('vip.top', [10]) },
  { id: 3, account: t('小店数据'), name: t('排序与筛选'), paid1: 'right', paid2: 'right', paid3: 'no' },
  { id: 4, account: t('达人数据'), name: t('达人库'), paid1: t('vip.不限'), paid2: t('vip.upTo', [2000]), paid3: t('vip.upTo', [10]) },
  { id: 4, account: t('达人数据'), name: t('达人详情'), paid1: t('vip.不限'), paid2: t('90天数据'), paid3: t('仅基础数据') },
  { id: 4, account: t('达人数据'), name: t('达人榜单'), paid1: t('vip.top', [1000]), paid2: t('vip.top', [500]), paid3: t('vip.top', [10]) },
  { id: 4, account: t('达人数据'), name: t('排序与筛选'), paid1: 'right', paid2: 'right', paid3: 'no' },
  { id: 4, account: t('达人数据'), name: t('联系方式查看'), paid1: 'right', paid2: 'right', paid3: 'no' },
  { id: 5, account: t('视频数据'), name: t('视频库'), paid1: t('vip.不限'), paid2: t('vip.upTo', [2000]), paid3: t('vip.upTo', [10]) },
  { id: 5, account: t('视频数据'), name: t('视频详情'), paid1: 'right', paid2: 'right', paid3: t('仅基础数据') },
  // { id: 5, account: t('视频数据'), name: t('视频榜单'), paid1: t('vip.top', [1000]), paid2: t('vip.top', [500]), paid3: t('vip.top', [10]) },
  { id: 5, account: t('视频数据'), name: t('排序与筛选'), paid1: 'right', paid2: 'right', paid3: 'no' },
  { id: 6, account: t('直播数据'), name: t('直播库'), paid1: t('vip.不限'), paid2: '2000条', paid3: t('vip.upTo', [10]) },
  { id: 6, account: t('直播数据'), name: t('直播详情'), paid1: 'right', paid2: 'right', paid3: t('仅基础数据') },
  { id: 6, account: t('直播数据'), name: t('直播榜单'), paid1: t('vip.top', [1000]), paid2: t('vip.top', [500]), paid3: t('vip.top', [10]) },
  { id: 6, account: t('直播数据'), name: t('排序与筛选'), paid1: 'right', paid2: 'right', paid3: 'no' },
  { id: 7, account: t('收藏'), name: t('达人'), paid1: t('vip.upTo', [2000]), paid2: t('vip.upTo', [600]), paid3: t('vip.upTo', [10]) },
  { id: 7, account: t('收藏'), name: t('商品'), paid1: t('vip.upTo', [2000]), paid2: t('vip.upTo', [600]), paid3: t('vip.upTo', [10]) },
  { id: 7, account: t('收藏'), name: t('小店'), paid1: t('vip.upTo', [2000]), paid2: t('vip.upTo', [600]), paid3: t('vip.upTo', [10]) },
  { id: 7, account: t('收藏'), name: t('视频'), paid1: t('vip.upTo', [2000]), paid2: t('vip.upTo', [600]), paid3: t('vip.upTo', [10]) },
  { id: 7, account: t('收藏'), name: t('直播'), paid1: t('vip.upTo', [2000]), paid2: t('vip.upTo', [600]), paid3: t('vip.upTo', [10]) },
  { id: 8, account: t('数据导出'), name: t('导出次数'), paid1: `500${t('次/月')}`, paid2: `100${t('次/月')}`, paid3: 'no' },
  { id: 8, account: t('数据导出'), name: t('列表数据导出'), paid1: t('vip.export', [3000]), paid2: t('vip.export', [200]), paid3: 'no' },
  { id: 8, account: t('数据导出'), name: t('详情数据导出'), paid1: t('vip.export', [3000]), paid2: t('vip.export', [200]), paid3: 'no' },
  { id: 8, account: t('数据导出'), name: t('收藏数据导出'), paid1: t('vip.export', [3000]), paid2: t('vip.export', [200]), paid3: 'no' },
  { id: 8, account: t('数据导出'), name: t('榜单数据导出'), paid1: t('vip.export', [3000]), paid2: t('vip.export', [200]), paid3: 'no' },
  { id: 9, account: t('达人联系方式导出'), name: t('导出次数'), paid1: `5${t('次/天')}`, paid2: 'no', paid3: 'no' },
  { id: 9, account: t('达人联系方式导出'), name: t('联系方式导出'), paid1: t('vip.export', [1000]), paid2: 'no', paid3: 'no' },
]
const accountRowspan = ref<any>({})
function dataSpanMethod({ record, column, rowIndex }: { record: TableData, column: TableColumnData, rowIndex: number }) {
  if (column.dataIndex === 'account') {
    const id = record.id
    // 如果这个 account 之前已经合并过，则返回 0
    if (accountRowspan.value[id] && rowIndex > 0 && tableData[rowIndex].id === tableData[rowIndex - 1].id) {
      return { rowspan: 0 }
    }

    // // 计算相同 account 的数量
    const rowspan = tableData.filter(item => item.id === id).length

    // // 标记这个 account 已经合并
    accountRowspan.value[id] = rowspan

    return { rowspan }
  }
  return { rowspan: 1 }
}
const boxRef = ref()
</script>

<template>
  <div ref="boxRef" class="g-vip__privilege relative flex flex-col items-center pt-80">
    <div class="text-center text-[--color-text-2]" mb-70 font-300>
      <div text-70>
        {{ $t('版本权益对比') }}
      </div>
      <div mt-8 text-18 font-300 tracking-4.4>
        EQUITY COMPARISON
      </div>
    </div>
    <DetailCommonStickyTop :showHeight="1300" class="box-border h-180">
      <div box-border h-180 py-12>
        <component :is="renderComparisonSection" />
      </div>
    </DetailCommonStickyTop>
    <component :is="renderComparisonSection" />
    <g-fold :foldHeight="732" direction="vertical" class="g-vip__privilege--content relative mt--12 box-border !w-1170 !rd-16">
      <div class="bg-white !rd-16" w-full pb-48 pt-60>
        <a-table
          :data="tableData"
          :columns="columns"
          :show-header="false"
          :pagination="false"
          :span-method="dataSpanMethod"
          :bordered="false"
          :hoverable="false"
          row-class="!h-48"
        >
          <template #tr>
            <tr />
          </template>
          <template #td="{ rowIndex, record, column }">
            <td
              class="border-2 border-r border-white border-solid !text-[--color-text-1]"
              :class="{ 'bg-[--color-fill-1] ': (rowIndex % 2 && column.dataIndex !== 'account') || (record.id % 2 === 0 && column.dataIndex === 'account'),
                        'px-24': record.account === '达人联系方式导出' && column.dataIndex === 'account',
                        '!font-500 !border-none': column.dataIndex === 'account',
              }"
            />
          </template>
          <template #package="{ record, column }">
            <g-svg v-if="['right', 'no'].includes(record[column.dataIndex])" :name="`vip/${record[column.dataIndex]}`" />
            <template v-else>
              {{ record[column.dataIndex] }}
            </template>
          </template>
        </a-table>
      </div>
    </g-fold>
  </div>
</template>

<style lang="less" scoped>
.g-vip__privilege {
  background:
  url('~/assets/images/user/vip/bg-cl.png') left 40px/521px auto no-repeat,
  url('~/assets/images/user/vip/bg-cr.png') calc(100% + 50px) -20px/820px auto no-repeat
}
</style>
